import { render, staticRenderFns } from "./ComplaintFollowUpDelete.vue?vue&type=template&id=a9a6524e&"
import script from "./ComplaintFollowUpDelete.vue?vue&type=script&lang=js&"
export * from "./ComplaintFollowUpDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports